// @mui
import { Theme } from "@mui/material/styles";
import {
  SxProps,
  TableRow,
  TableCell,
  TableHead,
  useTheme,
} from "@mui/material";

type Props = {
  headLabel: any[];
  sx?: SxProps<Theme>;
};

export default function TableHeader({ headLabel, sx }: Props) {
  const theme = useTheme();
  return (
    <TableHead sx={sx}>
      <TableRow
        sx={{
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
        }}
      >
        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align || "left"}
            sx={{
              width: headCell.width,
              minWidth: headCell.minWidth,
              borderTopRightRadius: "12px",
              borderTopLeftRadius: "12px",
            }}
          >
            {headCell}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
